exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-blog-post-archive-blog-post-archive-js": () => import("./../../../src/templates/BlogPostArchive/BlogPostArchive.js" /* webpackChunkName: "component---src-templates-blog-post-archive-blog-post-archive-js" */),
  "component---src-templates-wp-blog-post-wp-blog-post-js": () => import("./../../../src/templates/WpBlogPost/WpBlogPost.js" /* webpackChunkName: "component---src-templates-wp-blog-post-wp-blog-post-js" */)
}

